export default __webpack_public_path__ + "static/media/trabalho-e-renda.3f43366c.svg";